import { getLoggerManager } from '@/shared/logging'

let active = false
let elapsedMs = 0

/** CAD 帧诊断开启时，由线材质 updater 累加 dash scale 计算耗时。 */
export function startCadDashScaleTracking() {
  active = true
  elapsedMs = 0
}

export function stopCadDashScaleTracking(): number {
  active = false
  const value = elapsedMs
  elapsedMs = 0
  return value
}

export function measureCadDashScale<T>(callback: () => T): T {
  if (!active) return callback()
  const startedAt = getLoggerManager().now()
  try {
    return callback()
  } finally {
    elapsedMs += getLoggerManager().now() - startedAt
  }
}
